import '@/styles/index.scss'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ROOT } from '@/app/thread'
import PointerProvider from '@/lib/react/PointerProvider/PointerProvider'
import App from './App'
import RootProvider from './app/services/RootProvider/RootProvider'
import Loader from './components/interface/Loader/Loader'
import ModalProvider from './components/interface/Modal/provider/ModalProvider'

const root = createRoot(ROOT)

root.render(
  <BrowserRouter>
    <ModalProvider>
      <RootProvider>
        <Loader.Provider>
          <PointerProvider>
            <App />
          </PointerProvider>
        </Loader.Provider>
      </RootProvider>
    </ModalProvider>
  </BrowserRouter>
)
